import {LexicalEditor} from 'lexical';

const registry = new WeakMap<LexicalEditor, Set<string>>();

const forEditor = (editor: LexicalEditor): Set<string> => {
  let links = registry.get(editor);
  if(!links){
    links = new Set<string>();
    registry.set(editor,links);
  }
  return links;
}

export const getTrackedLinks = (editor: LexicalEditor): string[] => Array.from(forEditor(editor));
export const clearTrackedLinks = (editor: LexicalEditor) => forEditor(editor).clear();
export const trackLink = (editor: LexicalEditor, link: string) => forEditor(editor).add(link);
